"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var module = function (_a) {
    var addProvider = _a.addProvider, appConfig = _a.appConfig, wrapperRouteComponent = _a.wrapperRouteComponent, getSearchParams = _a.getSearchParams, createElement = _a.context.createElement;
    var _b = appConfig.app, app = _b === void 0 ? {} : _b;
    var _c = app.parseSearchParams, parseSearchParams = _c === void 0 ? true : _c;
    var wrapperPageComponent = function (PageComponent) {
        var WrapperedPageComponent = function (props) {
            var searchParams = parseSearchParams && getSearchParams();
            return createElement(PageComponent, __assign({}, Object.assign({}, props, { searchParams: searchParams })));
        };
        return WrapperedPageComponent;
    };
    wrapperRouteComponent(wrapperPageComponent);
    if (appConfig.app && appConfig.app.addProvider) {
        addProvider(appConfig.app.addProvider);
    }
};
exports.default = module;
